export const toPriceFormat = (val) => {
  return `￥${Number(val).toLocaleString()}`
}

export const addSpPriceMark = (val, pid) => {
  return val + ((pid == 0) ? '' : ' (特別価格商品)')
}
